'use strict'
import axios from 'axios'
import store from './store.provider'
import router from '../../router'

axios.interceptors.request.use(config => {
  // config.headers['X-Requested-With'] = 'XMLHttpRequest'
  if (router.currentRoute && router.currentRoute.meta.auth) {
    if (store.state.login.token) {
      // console.log(store.state.login.token)
      config.headers['Authorization'] = 'Bearer ' + store.state.login.token
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(
  response => {
    return response
  },
  async (error) => {
    if (error.response) {
      console.log(error.response)
      if (error.response.status === 401) {
        var token = store.state.login.token
        console.log(token)
        await axios.post('https://goapi.gmic.cn/api/v1/refresh_token', {'old_token': token}).then(res => {
          console.log('refresh')
          store.commit('setToken', res.data.data)
        }).catch(err => {
          console.log(err)
          store.dispatch('userLogoutAction').then(() => {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            })
          })
        })
        return axios.request(error.config)
      }
      // switch (error.response.status) {
      //   case 401:
      //     console.log(error.response)
      //     store.dispatch('userLogoutAction').then(() => {
      //       router.replace({
      //         path: '/login',
      //         query: {
      //           redirect: router.currentRoute.fullPath
      //         }
      //       })
      //     })
      //     break
      // }
      return Promise.reject(error.response)
    }
  }
)

const http = {}

http.get = function (url, params) {
  let config = {
    method: 'GET',
    url: url,
    params: params, // params:{ key : value}
    timeout: this.timeout,
    headers: {
      'Content-Type': 'application/xxxx-form; charset=UTF-8'
    },
    responseType: 'json'
  }
  return axios(config)
}

http.post = function (url, obj) {
  let config = {
    method: 'POST',
    url: url,
    data: JSON.stringify(obj), // change obj to qs
    timeout: this.timeout,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
      // 'Content-Type': 'text/html; charset=utf-8'
    },
    responseType: 'json'
  }
  return axios(config)
}

export default http



// WEBPACK FOOTER //
// ./src/common/provider/http.js